import styled from "styled-components";

export const DrawerOptionsList = styled.ul`
  padding: 48px 24px 24px 24px;
  list-style-type: none;
  color: var(--portal-secondary);
  font-size: 16px;
  font-weight: 500;

  > li {
    margin-bottom: 24px;

    > div > div > div {
        color: var(--portal-secondary);
    }

    ul {
      list-style-type: none;
      color: var(--portal-primary);
      margin-left: -36px;

      > li {
        margin-bottom: 24px;
      }
    }

    > div {
      box-shadow: none;
      > div {
        padding: 0px;
      }
    }
  }
`;
